import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiAlertError } from '@decorators/api-alert-error';
import { ContactSupport, ContactSupportJson } from '@models/contact-support';

import { ApiCommonService } from './api-common.service';

@Injectable({
  providedIn: 'root'
})
export class ContactSupportApiService extends ApiCommonService<ContactSupport> {
  resourceUrl: string = 'api/v1/expert/support/send';

  fromJson(json: ContactSupportJson): ContactSupport {
    throw new Error('Method not implemented.');
  }

  toJson(model: ContactSupport): ContactSupportJson {
    return ContactSupport.toJson(model);
  }

  @ApiAlertError()
  sendToSupport(contactSupport: ContactSupport): Observable<void> {
    const formData = new FormData();
    formData.append('reason', contactSupport.reason);
    formData.append('subject', contactSupport.subject);
    formData.append('description', contactSupport.description);
    formData.append('userId', contactSupport.userId?.toString() ?? null);

    (contactSupport.files || []).forEach((file: File) => formData.append(`files[]`, file));

    if (contactSupport.companyId) {
      formData.append('companyId', contactSupport.companyId.toString());
    }

    return this.http.post<void>(this.resourceUrl, formData);
  }
}
